import type { SxProps, Theme } from "@mui/material";

export const accessCheckFieldSx: SxProps<Theme> = {
  "& .MuiInputBase-root": { minHeight: "3rem" },
};

export const accessCheckButtonSx: SxProps<Theme> = {
  minHeight: "3.625rem",
};
